import _ from 'lodash';
import { curCoreClient } from './CoreClient';

export class DownlinkService {

  public async nanoUpdateFrequencies(deviceId:string, recordMin:number, reportMin:number): Promise<{errorMsg?:string, httpCode?:number}> {

    let recordMinHex = recordMin.toString(16);
    while(recordMinHex.length < 2)
    recordMinHex = `0${recordMinHex}`

    let reportMinHex = reportMin.toString(16);
    while(reportMinHex.length < 4)
      reportMinHex = `0${reportMinHex}`
    
    const hexPayload = `${recordMinHex}${reportMinHex}`;

    const resp = await curCoreClient.postMessages({
      deviceId,
      flushQueue: true,
      hexPayload,
      loraPort: 8
    });

    if (resp.errorMsg)
      return Promise.resolve({
        errorMsg: resp.errorMsg,
        httpCode: resp.httpCode
      });

    return Promise.resolve({});
  }

  public async aradMeterUpdateUplinkFrequency(deviceId:string, freqSec:number): Promise<{errorMsg?:string, httpCode?:number}> {

    const freqStr = ('' + freqSec)
      .split('')
      .map(letter => `3${letter}`)
      .join('');

    const hexPayload = `3930${freqStr}`;

    const resp = await curCoreClient.postMessages({
      deviceId,
      flushQueue: true,
      hexPayload,
      loraPort: 1
    });

    if (resp.errorMsg)
      return Promise.resolve({
        errorMsg: resp.errorMsg,
        httpCode: resp.httpCode
      });

    return Promise.resolve({});
  }

  // this is just a pass through and may be removed in the future
  public async sendRawDownlink(downlinkReq:RawDownlinkReq):Promise<{errorMsg?:string, httpCode?:number}> {
      
      const resp = await curCoreClient.postMessages(downlinkReq);

      if (resp.errorMsg)
        return Promise.resolve({errorMsg: resp.errorMsg, httpCode: resp.httpCode });

      return Promise.resolve({});
    }

}

export interface RawDownlinkReq {
  deviceId:string, 
  loraPort:number, 
  hexPayload:string, 
  flushQueue:boolean,
  downlinkCounter?: number;
  validityTime?: number;
}


export const curDownlinkService = new DownlinkService();
